exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.com-button-icon {\n  cursor: pointer;\n  display: inline-flex;\n  border-radius: 3px;\n  padding: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #3f506e;\n}\n.com-button-icon--active {\n    padding: 2px;\n    border: #1fc8db solid 1px;\n    background-color: #c7d6e1;\n}\n", ""]);

// exports
